import BoxWidget from '@/components/box-widget/BoxWidget.vue';

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'box-widget': BoxWidget,
  },
  methods: {
    loadMore() {
      this.$emit('load');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/notifications-box/NotificationsBox.js